import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchTagsResponseEntity } from '../../domain/entities/BranchResponseEntity'
import { BranchTagsMiniModel } from './BranchTagsMiniModel'
import type { BranchTagsMiniEntity } from '../../domain/entities/BranchTagsMiniEntity'


export class BranchTagsResponseModel extends BranchTagsResponseEntity {
  constructor(dataDto: BranchTagsResponseEntity) {
    super()
    const branchTagsMiniModel = dataDto.items?.map((item: BranchTagsMiniEntity) => new BranchTagsMiniModel(item))
    mapEntityProperties<BranchTagsResponseEntity>(this, dataDto, {
      map: {
        items: branchTagsMiniModel
      }
    })
  }
}
